import React from 'react';
import { motion } from 'framer-motion';
import { Rocket } from 'lucide-react';
import { IllustrationCalendar, IllustrationTarget, IllustrationMoneyStack } from './BonusIllustrations';
const proBonuses = [{
  num: 1,
  title: 'Calendario Financiero de 12 Meses',
  desc: 'Planificá todo tu año financiero.',
  Illustration: IllustrationCalendar
}, {
  num: 2,
  title: 'Planificador de Objetivos Económicos',
  desc: 'Convertí metas financieras en resultados concretos.',
  Illustration: IllustrationTarget
}, {
  num: 3,
  title: 'Sistema $100.000 Extra',
  desc: 'Estrategias prácticas para generar ingresos adicionales.',
  Illustration: IllustrationMoneyStack
}];
export function KitProBonuses() {
  return <section className="py-16 bg-slate-50" data-id="element-268">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-269">
        <motion.div className="bg-white rounded-3xl shadow-xl border border-slate-200 overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-270">
          <div className="bg-gradient-to-r from-navy-900 to-navy-800 p-6 md:p-10 text-center text-white relative overflow-hidden" data-id="element-271">
            <div className="absolute top-0 right-0 w-64 h-64 bg-success/20 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none" data-id="element-272"></div>
            <div className="relative z-10" data-id="element-273">
              <div className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full text-xs font-bold tracking-wider uppercase mb-4 border border-white/20 backdrop-blur-sm" data-id="element-274">
                <Rocket className="w-3.5 h-3.5 text-success" data-id="element-275" /> Exclusivo
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold mb-3" data-id="element-276">
                KIT PRO — 3 BONUS PLUS PREMIUM
              </h2>
              <p className="text-sm md:text-base text-slate-300 max-w-2xl mx-auto" data-id="element-277">
                Llevá tu organización al siguiente nivel con herramientas
                avanzadas de planificación.
              </p>
            </div>
          </div>

          <div className="p-5 md:p-8" data-id="element-278">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6" data-id="element-279">
              {proBonuses.map((bonus, index) => {
              const Illustration = bonus.Illustration;
              return <motion.div key={index} className="flex flex-col items-center text-center bg-navy-50/50 rounded-2xl p-4 border border-slate-100" initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.1
              }} data-id="element-280">
                    <div className="w-full aspect-square max-w-[140px] mb-3 bg-white rounded-xl overflow-hidden shadow-sm border border-slate-100" data-id="element-281">
                      <Illustration data-id="element-282" />
                    </div>
                    <div className="text-[10px] font-bold text-success mb-1 uppercase tracking-wider" data-id="element-283">
                      BONUS PLUS {bonus.num}
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-navy-900 mb-1 leading-tight" data-id="element-284">
                      {bonus.title}
                    </h3>
                    <p className="text-xs md:text-sm text-slate-600 leading-snug" data-id="element-285">
                      {bonus.desc}
                    </p>
                  </motion.div>;
            })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}